<div class="d-flex" id="wrapper">

  <!-- Sidebar -->
  <div class="bg-light border-right" id="sidebar-wrapper">
    <div class="sidebar-heading">Seleziona Parco </div>
    <div class="list-group list-group-flush">
      <div class="form-group">
        <div class="form-check"  *ngFor="let parkType of parkTypes">
          <input class="form-check-input" type="radio" id="{{'checkPT' + parkType['id']}}"
                 name="exampleRadiosSuperAdmin" (change)="parkTypeChanged(parkType)">
          <label class="form-check-label" for="{{'checkPT' + parkType['id']}}">
            {{ parkType['name'] }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label for="parkSelect">Scegli il parco</label>
        <select class="form-control" id="parkSelect" [(ngModel)]="selectedPark" (ngModelChange)="selectParkChange($event)">
          <option *ngFor="let park of visibleParks" [ngValue]="park">
            {{ park['name'] }}
          </option>
        </select>
      </div>

      <button class="btn btn-outline-primary btn-link-sa" routerLink="vehicle-search">Cerca Targa Veicolo</button>
      <button class="btn btn-outline-primary btn-link-sa" routerLink="brands-and-models">Marche & Modelli</button>
      <button class="btn btn-outline-primary btn-link-sa" routerLink="createpark">Nuovo Parco</button>
      <button class="btn btn-outline-primary btn-link-sa" [routerLink]="['manage-vehicle-auth',parkId,parkName]" [disabled]="!selectedPark">Auto Autorizzate</button>
      <button class="btn btn-outline-primary btn-link-sa" [routerLink]="['profiles',parkId,parkName]" [disabled]="!selectedPark">Profili</button>
      <button class="btn btn-outline-primary btn-link-sa" [routerLink]="['refuels',parkId,parkName]" [disabled]="!selectedPark">Rifornimenti</button>
      <button class="btn btn-outline-primary btn-link-sa" [routerLink]="['vehicles',parkId,parkName]" [disabled]="!selectedPark">Veicoli</button>
      <button class="btn btn-outline-primary btn-link-sa" [routerLink]="['travels',parkId,parkName]" [disabled]="!selectedPark">Viaggi</button>

    </div>
  </div>

  <!-- Page Content -->
  <div id="page-content-wrapper">

    <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom">
     <!-- spazio libero -->
    </nav>

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>

</div>

